import React, { useState } from 'react';

export function ImageWithFallback({ src, alt, className, fallbackSrc = 'https://via.placeholder.com/400x300?text=Medical+Care' }) {
  const [imgSrc, setImgSrc] = useState(src);
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    if (!hasError) {
      setHasError(true);
      setImgSrc(fallbackSrc);
    }
  };

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      onError={handleError}
    />
  );
}

